import { Router } from '@angular/router';
import { KontableComponent } from './../../../modules/UIKit/components/kontable/kontable.component';
import { AppConfig } from './../../../models/app-config.model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClientService } from '../../../services/httpClient/httpclient.service';

@Component({
  selector: 'app-apps-config',
  templateUrl: './apps-config.component.html',
  styleUrls: ['./apps-config.component.css']
})
export class AppsConfigComponent implements OnInit {
  configs: AppConfig[] = [];
  @ViewChild('appsConfigTable') appsConfigTable: KontableComponent;


  constructor(private http: HttpClientService, private router: Router) { }

  ngOnInit() {
    this.http.get('/koncentro-api/kwallet/getAppConfig?ui=1').subscribe(res => {
      res.rsp_data.forEach(r => this.configs.push({
        id: r.id,
        appId: r.appId,
        appHostCode: r.appHostCode,
        configKey: r.configKey
      }));
      this.appsConfigTable.refresh();
    })
  }

  goToForm(appId: string,configKey:string, readOnly: boolean) {
    if (configKey) {
      if (readOnly) {
        this.router.navigate([`apps-config/${appId}/${configKey}/readonly`]);
      } else {
        this.router.navigate([`apps-config/${appId}/${configKey}`]);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/apps-config.component.ts